// Hands the checkout payload from the confirm screen to the unified
// confirmation screen WITHOUT putting guest names, email, or phone in the URL
// (personal data must never live in query params). An in-memory singleton is
// enough: it's a same-session, single-consumer handoff.

export interface PendingCheckout {
  bookHash: string;
  rooms: Array<{ firstName: string; lastName: string }>;
  contact: { email: string; phone: string };
  payment: Api.Payment.Initiate.Body;
}

let pending: PendingCheckout | null = null;

export function stashCheckout(payload: PendingCheckout): void {
  pending = payload;
}

// Not cleared on read, so a retry within the same session still works.
export function peekCheckout(): PendingCheckout | null {
  return pending;
}
